// import { Component } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import { FormsModule } from '@angular/forms';
// import { Router, RouterLink } from '@angular/router';
// import { ApiService } from '../../core/api.service';
// import { ActivatedRoute } from '@angular/router';

// @Component({
//   selector: 'app-customer-login',
//   standalone: true,
//   imports: [CommonModule, FormsModule, RouterLink],
//   templateUrl: './customer-login.component.html',
//   styleUrl: './customer-login.component.css'
// })
// export class CustomerLoginComponent {
//   email = '';
//   password = '';
//   loading = false;
//   error = '';

// constructor(
//   private api: ApiService,
//   private router: Router,
//   private route: ActivatedRoute
// ) {}




//   login() {
//     this.error = '';

//     if (!this.email || !this.password) {
//       this.error = 'Informe e-mail e senha.';
//       return;
//     }

//     this.loading = true;

//     this.api.post<any>('/customer-auth/login', {
//       email: this.email,
//       password: this.password
//     }).subscribe({
//       next: (response) => {
//         localStorage.setItem('customer_token', response.token);
//         localStorage.setItem('customer_user', JSON.stringify(response.customer));
//         this.loading = false;
//          const returnUrl =
//     this.route.snapshot.queryParamMap.get('returnUrl');

//   if (returnUrl) {
//     this.router.navigateByUrl(returnUrl);
//   } else {
//     this.router.navigate(['/']);
//   }
//         //this.router.navigate(['/customer/orders']);
//       },
//       error: (err) => {
//         this.loading = false;
//         this.error = err?.error?.message || 'Erro ao fazer login.';
//       }
//     });
//   }
// }


import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  ActivatedRoute,
  Router,
  RouterLink
} from '@angular/router';

import { ApiService } from '../../core/api.service';

@Component({
  selector: 'app-customer-login',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterLink
  ],
  templateUrl: './customer-login.component.html',
  styleUrl: './customer-login.component.css'
})
export class CustomerLoginComponent {

  email = '';
  password = '';

  loading = false;
  error = '';

  constructor(
    private api: ApiService,
    private router: Router,
    private route: ActivatedRoute
  ) {}


  login(): void {

    this.error = '';

    if (
      !this.email.trim() ||
      !this.password
    ) {

      this.error =
        'Informe e-mail e senha.';

      return;
    }


    this.loading = true;


    this.api
      .post<any>(
        '/customer-auth/login',
        {
          email:
            this.email
              .trim()
              .toLowerCase(),

          password:
            this.password
        }
      )
      .subscribe({

        next: (response) => {

          localStorage.setItem(
            'customer_token',
            response.token
          );


          localStorage.setItem(
            'customer_user',
            JSON.stringify(
              response.customer
            )
          );


          this.loading = false;


          /*
           * 1. Primeiro tenta pegar o returnUrl
           * enviado pelo cardápio.
           */
          const queryReturnUrl =
            this.route.snapshot
              .queryParamMap
              .get('returnUrl');


          /*
           * 2. Caso tenha se perdido,
           * tenta recuperar o cardápio salvo.
           */
          const storedReturnUrl =
            sessionStorage.getItem(
              'customer_return_url'
            );


          const returnUrl =
            queryReturnUrl ||
            storedReturnUrl;


          if (returnUrl) {

            /*
             * Limpa depois de usar.
             */
            sessionStorage.removeItem(
              'customer_return_url'
            );


            /*
             * Volta exatamente para o cardápio
             * em que o cliente estava.
             */
            this.router.navigateByUrl(
              returnUrl
            );

            return;
          }


          /*
           * Só deve acontecer se a pessoa
           * entrar diretamente pela URL
           * /customer/login
           */
          this.router.navigate(['/']);

        },


        error: (err) => {

          this.loading = false;

          this.error =
            err?.error?.message ||
            'Erro ao fazer login.';

        }

      });

  }

}